// import { fromJS } from 'immutable';
import * as Constants from './Constants';

const initialState = {
  updateContactInfo: false,
  updateShippingAdressflag: false,
  isInvalidAddressError: false,
  updateShippingAdressResponse: {},
  marketDetails: {},
  apiFailureError: false,
  isInvalidOTP: false,
  updateValidateOTPResponse: {},
  shippingInvalidError: false,
  ISPUzipCode: '',
  shippingServiceInfo: null,
  shippingInfoError: false,
  shippingInfoNtfyMsg: null,
  showIspuStoreError: false,
  storeListUpdated: false,
  shippingAddress2UnitItems: 0,
  shippingAddress2UnitArray: [],
  shippingAddressEdit: false,

};

function shippingInfo(state = initialState, action) {
  // debugger;
  switch (action.type) {
    case Constants.GET_DATA_SUCCESS:
      return { ...state, title: action.response && action.response.data };
    case Constants.GET_DETAILS_FROM_API_SUCCESS:
      return { ...state, ShippingInfoDetails: action.response };
    case Constants.GET_SLOTS_SDD_SUCCESS:
      return { ...state, sddSlots: action.response };
    case Constants.GET_ENABLED_DEVICES_SUCCESS:
      return { ...state, securePinData: action.response };
    case 'CLEAR_DEVICES_STORE':
      return { ...state, securePinDataDeviceSucess: {} };
    case Constants.FETCH_SMS_DEVICES_SUCCESS:
      return { ...state, securePinDataDeviceSucess: action.response, isInvalidOTP: false, ...action.commonData };
    case Constants.CODE_VALIDATION_SUCCESS:
      return { ...state, otpSuccess: action.response };
    case Constants.GET_SEND_SMS_SUCCESS:
      return { ...state, getSmsSuccess: action.response };
    case Constants.UPDATE_SHIPPING_ADDRESS_SUCCESS:
      return { ...state, updateShippingAdressResponse: action.response, isInvalidAddressError: false };
    case 'INVALID_ADDRESS':
      return { ...state, isInvalidAddressError: true, updateShippingAdressResponse: action.response, shippingServiceInfo: action.serviceinfo };
    case 'CLEAR_INVALID_RESPONSE':
      return { ...state, isInvalidAddressError: false };
    case 'CLEAR_SHIPPING_OTP_EXIPIRE':
      return { ...state, AUTH_CODE_VERIFICATION_ERROR: '' };
    // GET_SEND_SMS_SUCCESS
    case 'CITY_AND_STATE_SUCCESS':
      return { ...state, marketDetails: action.response };
    case 'CLEAR_MARKET_DETAILS':
      return { ...state, marketDetails: {} };
    case 'SELECTED_SHIPPING_VALUE': {
      const storeUpdate = action.selectedValue !== 'ISPU' ? { ispuStoreInfo: null } : {};
      return { ...state, selectedValue: action.selectedValue, ...storeUpdate };
    }
    case 'UPDATE_SAVE_SELECTED_OPTION':
      return { ...state, selectedShippingOption: action.data };
    case Constants.UPDATE_ADRESS_SUUCESS: {
      const preState = state.updateShippingAdressflag;
      return { ...state, updateShippingAdressflag: !preState };
      // return { ...state, updateShippingAdressflag: true };
    }
    // UPDATE_ADRESS_SUUCESS
    case 'CEF_ISPU_STORES_RECEIVED':
      return {
        ...state,
        showIspuStoreError: action.response,
      };
    case 'ISPU_STORES_RECEIVED':
      return {
        ...state,
        storeList: action.response,
        isFetching: false,
      };
    case 'ISPU_STORES_UPDATED':
      return {
        ...state,
        storeListUpdatedValue: action.response,
      };

    case 'ISPU_FETCHING':
      return {
        ...state,
        storeList: [],
        isFetching: true,
      };
    case 'UPDATE_ISPU_SHIPPING_OPTION_RECIEVED':
      return { ...state, cart: action.response.cartVo.data.cart };
    case Constants.UPDATE_ISPU_STORE_INFO:
      return { ...state, ispuStoreInfo: action.response };
    // UPDATE_CONTACT_SUCCESS
    case 'UPDATE_CONTACT_SUCCESS': {
      const preState = state.updateContactInfo;
      // return { ...state, updateSetup: !preState };
      return {
        ...state,
        contactSuccess: action.response,
        updateContactInfo: !preState,
      };
    }
    case 'TOGGLE_CONTACT_SUCCESS':
      return { ...state, updateContactInfo: false };
    case 'PAYMENT_SKIP_CALL':
      return { ...state, paymentSkipCall: action.value };
    case 'IS_BTA_ELIGIBLE':
      return { ...state, isBTAEligible: action.value };
    case Constants.GET_SHIPPING_OPTION_HEADER:
      return { ...state, shippingHeader: action.value };
    case Constants.ERR_OCCURED:
      return { ...state, apiFailureError: action.errorShipping, shippingServiceInfo: action.serviceinfo };
    case Constants.SET_ISPU_MODAL:
      return { ...state, openISPUModal: true };
    case Constants.RESET_ISPU_MODAL:
      return { ...state, openISPUModal: false };
    case Constants.SHIPPING_FETCH_SMS_DEVICES_ERROR:
      return { ...state, updateValidateOTPResponse: action.response };
    case Constants.SHIPPING_INVALID_CASE_ERROR:
      return { ...state, shippingInvalidError: action.response, shippingServiceInfo: action.serviceinfo };
    case 'ISPU_ZIPCODE':
      return { ...state, ISPUzipCode: action.response };
    case 'EMAIL_VALIDATION':
      return { ...state, emailAPiResponse: action.response, accMainEmailVal: action.response.accMainEmailVal };
    case Constants.ACC_MAIN_EMAIL_VALIDATION:
      return { ...state, accMainEmailVal: action.response };
    case Constants.CEF_SHIPPING_INFO_ERROR:
      return { ...state, shippingInfoError: action.response, shippingInfoNtfyMsg: action.errorMessage };
    case 'SHIPPING_ADDRESS2_UNIT_ITEMS':
        return { ...state, shippingAddress2UnitItems: action.data && action.data };
    case 'SHIPPING_ADDRESS2_UNIT_ARRAY':
        return { ...state, shippingAddress2UnitArray: action.data && action.data };
    case 'SHIPPING_ADDRESS_CHANGE':
        return { ...state, shippingAddressEdit: action.data && action.data };
    default:
      return state;
  }
}

export default shippingInfo;
